import type { IconType } from "react-icons";
import {
  FiBarChart2,
  FiBell,
  FiBookOpen,
  FiCamera,
  FiTrendingUp,
} from "react-icons/fi";

export interface NewsCategoryRecord {
  id: string;
  title: string;
  description: string;
  heroTitle: string;
  heroSubtitle: string;
  icon: IconType;
  accentColor: string;
}

export const NEWS_CATEGORIES: NewsCategoryRecord[] = [
  {
    id: "announcements",
    title: "اخبار و اطلاعیه‌ها",
    description:
      "خبرها، اطلاعیه‌های رسمی، رویدادها و به‌روزرسانی‌های مهم شرکت در یک آرشیو منظم و محتوامحور.",
    heroTitle: "اخبار و اطلاعیه‌های رسمی",
    heroSubtitle:
      "در این بخش می‌توانید آخرین خبرها، اطلاعیه‌ها و اطلاع‌رسانی‌های رسمی تأمین سرمایه امید را دنبال کنید.",
    icon: FiBell,
    accentColor: "brand",
  },
  {
    id: "multimedia",
    title: "چندرسانه‌ای",
    description:
      "گزارش‌های تصویری، آلبوم رویدادها و محتوای رسانه‌ای برای مرور سریع و بصری فعالیت‌ها.",
    heroTitle: "چندرسانه‌ای و آلبوم رویدادها",
    heroSubtitle:
      "گزارش‌های تصویری، آلبوم‌ها و روایت‌های بصری از رویدادها و فعالیت‌های تأمین سرمایه امید در این بخش قرار می‌گیرد.",
    icon: FiCamera,
    accentColor: "orange",
  },
  {
    id: "statistical-reports",
    title: "گزارش‌های آماری",
    description:
      "مرور داده‌ها، شاخص‌ها و بسته‌های خلاصه آماری برای تصمیم‌گیری سریع‌تر و دقیق‌تر.",
    heroTitle: "گزارش‌های آماری",
    heroSubtitle:
      "این بخش برای انتشار گزارش‌های آماری، شاخص‌های کلیدی و بسته‌های منظم گزارش‌دهی طراحی شده است.",
    icon: FiBarChart2,
    accentColor: "teal",
  },
  {
    id: "financial-reports",
    title: "گزارش‌های مالی",
    description:
      "صورت‌های مالی، گزارش‌های عملکرد و مستندات مالی منتشرشده برای دسترسی ساختاریافته و سریع.",
    heroTitle: "گزارش‌های مالی",
    heroSubtitle:
      "در این بخش صورت‌های مالی، گزارش‌های عملکرد و مستندات مالی تأمین سرمایه امید در دسترس قرار می‌گیرد.",
    icon: FiBarChart2,
    accentColor: "cyan",
  },
  {
    id: "publications",
    title: "انتشارات",
    description:
      "نشریات، بولتن‌ها، کتابچه‌ها و بسته‌های محتوایی که برای معرفی خدمات و انتقال دانش آماده می‌شوند.",
    heroTitle: "انتشارات و بولتن‌ها",
    heroSubtitle:
      "برای انتشار بولتن‌ها، کتابچه‌ها، بروشورها و بسته‌های محتوایی، یک آرشیو ساختاریافته و قابل جست‌وجو در نظر گرفته شده است.",
    icon: FiBookOpen,
    accentColor: "purple",
  },
  {
    id: "analysis",
    title: "مقالات و تحلیل‌ها",
    description:
      "محتوای آموزشی و تحلیلی برای مرور روندها، سناریوها و نگاه عمیق‌تر به بازار سرمایه.",
    heroTitle: "مقالات و تحلیل‌های بازار",
    heroSubtitle:
      "در این بخش مقالات آموزشی، تحلیل‌های کاربردی و یادداشت‌های تخصصی بازار سرمایه در دسترس قرار می‌گیرد.",
    icon: FiTrendingUp,
    accentColor: "green",
  },
];

export const getNewsCategoryById = (categoryId?: string) =>
  NEWS_CATEGORIES.find((category) => category.id === categoryId);
